import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckSMTPController::__invoke
* @see app/Http/Controllers/CheckSMTPController.php
* @route '/api/smtp/check'
*/
const CheckSMTPController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CheckSMTPController.url(options),
    method: 'post',
})

CheckSMTPController.definition = {
    methods: ["post"],
    url: '/api/smtp/check',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CheckSMTPController::__invoke
* @see app/Http/Controllers/CheckSMTPController.php
* @route '/api/smtp/check'
*/
CheckSMTPController.url = (options?: RouteQueryOptions) => {
    return CheckSMTPController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckSMTPController::__invoke
* @see app/Http/Controllers/CheckSMTPController.php
* @route '/api/smtp/check'
*/
CheckSMTPController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CheckSMTPController.url(options),
    method: 'post',
})

export default CheckSMTPController